import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isNil} from "lodash"
import Snackbar from '@material-ui/core/Snackbar'
import Icon from 'components/icon'
import Button from "components/button"
import Loading from 'components/loading'
import themeVars from "theme/themeVars"

const DEFAULT_HIDE_DURATION = 5000

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  message: {
    paddingLeft: 5,
  },
  snackbarBody: {
    maxWidth: 'none',
  },
  snackbarContent: {
    display: 'flex',
  },
}

class SnackbarWrapper extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: props.open,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({
        open: this.props.open,
      })
    }
  }

  render() {
    const {open} = this.state
    const {icon, iconColor, autoHide, allowClose, onRequestClose} = this.props
    let {message, autoHideDuration, action} = this.props

    if (!autoHide) {
      autoHideDuration = null

      if (!action && allowClose) {
        action = (
          <Button
            flat={true}
            label={'Close'}
            onClick={onRequestClose}
            secondary={true}
          />
        )
      }
    }

    let iconElm
    // Note: using white as against dark background
    if (!isNil(icon)) {
      if (icon === 'loading') {
        iconElm = (
          <Loading
            color={themeVars.palette.whiteColor}
            inline={true}
            size={0.5}
            transparent={true}
          />
        )
      } else {
        iconElm = <Icon name={icon} color={iconColor || themeVars.palette.whiteColor}/>
      }
    }

    message = (
      <div style={styles.container}>
        {iconElm}
        <span style={styles.message}>{message}</span>
      </div>
    )

    return (
      <Snackbar
        action={action}
        autoHideDuration={autoHideDuration}
        className={"snackbar"}
        ContentProps={{
          style: {
            maxWidth: 'none',
            display: 'flex',
          },
        }}
        message={message}
        onClose={onRequestClose}
        open={open}
      />
    )
  }
}

SnackbarWrapper.propTypes = {
  action: propTypes.node,
  allowClose: propTypes.bool,
  autoHide: propTypes.bool,
  autoHideDuration: propTypes.number,
  icon: propTypes.string,
  iconColor: propTypes.string,
  message: propTypes.any,
  onActionClick: propTypes.func,
  onActionTouchTap: propTypes.func,
  onRequestClose: propTypes.func,
  open: propTypes.bool,
}

SnackbarWrapper.defaultProps = {
  allowClose: true,
  autoHide: true,
  autoHideDuration: DEFAULT_HIDE_DURATION,
  message: '',
  open: true,
}

export default SnackbarWrapper
